import { render, staticRenderFns } from "./OfferSettings.vue?vue&type=template&id=47fd5598"
import script from "./OfferSettings.vue?vue&type=script&lang=js"
export * from "./OfferSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports